import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import TextField from 'components/molecules/Fields/TextField/TextField';

const StyledLinkField = styled(TextField)`
  .TextField-readOnly {
    > .Span, > .Span > .Link {
      line-break: anywhere;
    }
  }
  
  &.LinkField-showLinkIcon {
    .TextField-readOnly {
      > *:not(.Icon, .InputAdornment) {
        flex-grow: 1;
        width: 1px;
        max-width: fit-content;
      }
      
      .InputAdornment {
        .Link > .Icon {
          color: ${props => props.theme.property('palette.action.active')};
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledLinkField.propTypes = {
  theme: PropTypes.object
};

export default StyledLinkField;
